import { render, staticRenderFns } from "./official.vue?vue&type=template&id=4c0bff8f&scoped=true&"
import script from "./official.vue?vue&type=script&lang=js&"
export * from "./official.vue?vue&type=script&lang=js&"
import style0 from "./official.vue?vue&type=style&index=0&id=4c0bff8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0bff8f",
  null
  
)

export default component.exports